import React, { useEffect, useRef } from "react"
import { spotify } from './spotify-embed.module.css'
import { trackEvent } from "../../modules/analytics";

const SpotifyEmbed = ({ title, link }) => {
  const iframeRef = useRef(null);
  let hasPlayed = false;

  const urlObject = new URL(link);
  // remove query parameters, because they might include parameters to instruct browser to open Spotify app on page load
  if (urlObject.pathname.substring(0, 6) !== '/embed') {
    urlObject.pathname = '/embed' + urlObject.pathname;
  }
  const cleanUrl = urlObject.origin + urlObject.pathname + '?theme=0';

  useEffect(() => {
    const receiveMessage = (event) => {
      if (event.data.type === "playback_update") {
        if (!event.data.payload.isPaused && !hasPlayed) {
          hasPlayed = true;
          trackEvent('cta_audio_play')
        }
      }
    };

    window.addEventListener('message', receiveMessage);

    return () => {
      window.removeEventListener('message', receiveMessage);
    };
  }, []);

  const loadSpotifyPlayer = () => {
    const iframe = iframeRef.current;

    if (iframe) {
      iframe.contentWindow.postMessage(
        {
          type: 'listening',
        },
        'https://open.spotify.com'
      );
    }
  };

  return (
    <section className={spotify}>
      <iframe ref={iframeRef} title={title} src={cleanUrl} onLoad={loadSpotifyPlayer} width="100%" height="232" frameBorder="0" allowtransparency="true" allow="encrypted-media"></iframe>
    </section>
  )
}

export default SpotifyEmbed